import { useSearchParams } from 'react-router-dom'
import { Box, Tab, Tabs, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { PageHelpPopover } from '@/components/common/PageHelpPopover'
import { PaymentsTab } from '@/components/admin/finance/PaymentsTab'
import { AdminContractTransactionsTab } from '@/components/admin/finance/AdminContractTransactionsTab'
import { AdminBalanceTransactionsTab } from '@/components/admin/finance/AdminBalanceTransactionsTab'
import 'dayjs/locale/ru'
import 'dayjs/locale/en'

const TABS = ['platform', 'contracts', 'balance'] as const
type FinanceTab = (typeof TABS)[number]

export function AdminFinancePage() {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const raw = searchParams.get('tab') ?? ''
  const tab: FinanceTab = (TABS as readonly string[]).includes(raw) ? (raw as FinanceTab) : 'platform'

  return (
    <DashboardLayout>
      <Box sx={{ p: 3, pt: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mb: 2 }}>
          <Typography variant="h4" component="h1" fontWeight={700}>
            {t('admin.finance.title', 'Финансовый журнал')}
          </Typography>
          <PageHelpPopover pageKey="admin-finance" />
        </Box>

        <Tabs
          value={tab}
          onChange={(_, value: string) => setSearchParams({ tab: value })}
          sx={{ mb: 3 }}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab value="platform" label={t('admin.finance.tabs.platform', 'Платформа')} />
          <Tab value="contracts" label={t('admin.finance.tabs.contracts', 'Контракты')} />
          <Tab value="balance" label={t('admin.finance.tabs.balance', 'Баланс учителей')} />
        </Tabs>

        {tab === 'platform' && <PaymentsTab />}
        {tab === 'contracts' && <AdminContractTransactionsTab />}
        {tab === 'balance' && <AdminBalanceTransactionsTab />}
      </Box>
    </DashboardLayout>
  )
}
